import { render, staticRenderFns } from "./MatrixView.vue?vue&type=template&id=03a8e6ca&scoped=true&"
import script from "./MatrixView.vue?vue&type=script&lang=js&"
export * from "./MatrixView.vue?vue&type=script&lang=js&"
import style0 from "./MatrixView.vue?vue&type=style&index=0&id=03a8e6ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a8e6ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03a8e6ca')) {
      api.createRecord('03a8e6ca', component.options)
    } else {
      api.reload('03a8e6ca', component.options)
    }
    module.hot.accept("./MatrixView.vue?vue&type=template&id=03a8e6ca&scoped=true&", function () {
      api.rerender('03a8e6ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/form/data/components/MatrixView.vue"
export default component.exports